module.exports = __webpack_public_path__ + "img/health31_7-9-2021.61a11528.jpg";